/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgItalicD = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1794 801q0 124-24 244t-78 233q-65 138-160 235t-214 160-255 90-282 29H254L608 128h463q156 0 288 44t229 129 151 211 55 289zm-204 14q0-134-41-230t-116-159-179-92-231-30H769L488 1616h310q181 0 327-57t250-163 159-253 56-328z"
    }));
export default SvgItalicD;
